import * as types from './types';
import SPBackend from '../../../services/SPBackend';
import { log } from '../../../utils/jsUtils';
import { setAccountUsage } from '../user/actions';

// Action creators
export const setBilling = (billing) => {
  log('[setBilling] Setting billing data:', billing);
  log('[setBilling] subscriptionId:', billing?.subscriptionId);
  log('[setBilling] subscriptionStatus:', billing?.subscriptionStatus);

  return {
    type: types.SET_BILLING,
    payload: billing
  };
};

export const setPlanId = (planId) => ({
  type: types.SET_PLAN_ID,
  payload: planId
});

export const setSubscriptionId = (subscriptionId) => ({
  type: types.SET_SUBSCRIPTION_ID,
  payload: subscriptionId
});

export const setSubscriptionStatus = (status) => ({
  type: types.SET_SUBSCRIPTION_STATUS,
  payload: status
});

export const setPlanInfo = (planInfo) => ({
  type: types.SET_PLAN_INFO,
  payload: planInfo
});

export const setProductInfo = (productInfo) => ({
  type: types.SET_PRODUCT_INFO,
  payload: productInfo
});

export const setSubscriptionInfo = (subscriptionInfo) => ({
  type: types.SET_SUBSCRIPTION_INFO,
  payload: subscriptionInfo
});

export const refreshBilling = () => ({
  type: types.REFRESH_BILLING
});

// Thunk action creators
export const fetchPlanInfo = (subscriptionId, user) => async (dispatch) => {
  try {
    if (!subscriptionId || !user) return;

    const response = await SPBackend.getPlanInfo(subscriptionId, user);
    const { data } = response;
    log('[fetchPlanInfo] response data:', data);

    const { plan, product, subscription, account } = data;

    dispatch(setPlanInfo(plan));
    dispatch(setProductInfo(product));
    dispatch(setSubscriptionInfo(subscription));

    // Create billing data object
    const billingData = {
      customerId: account.Billing ? account.Billing.CustomerId : null,
      subscriptionId: subscription.id,
      subscriptionStatus: subscription.status,
      planId: plan ? plan.id : null
    };

    // Set billing data as-is (trust the backend)
    dispatch(setBilling(billingData));

    // Also update the legacy Redux store for backward compatibility
    dispatch({
      type: 'ACTION_SET_BILLING',
      billing: billingData
    });

    // Update account usage in user module
    if (account.Usage) {
      dispatch(setAccountUsage(account.Usage));
    }

    // Increment refreshIndex so components re-fetch local state
    dispatch(refreshBilling());

    return data;
  } catch (error) {
    log('[fetchPlanInfo] error:', error.message);

    // Only clear billing data if API returns 404 (subscription not found in Stripe)
    // This handles truly orphaned data, not legitimate subscription states
    if (error.status === 404) {
      log('[fetchPlanInfo] Subscription not found in Stripe API, clearing data');
      dispatch(setBilling({
        customerId: null,
        subscriptionId: null,
        subscriptionStatus: 'na',
        planId: null
      }));
    }

    return null;
  }
}; 